module.exports = __webpack_public_path__ + "img/sq2.6c9e905f.png";